module.exports = __webpack_public_path__ + "img/flt_pt_fine_bolt.prt.b4429855.jpg";